fragment FixedBoxImagesFragment on fixedBoxImages_Entry {
  typeHandle
  heading
  captionedImages {
    ... on captionedImagesBlock_Entry {
      id
      image {
        url
        title
      }
      caption
    }
  }
}
